import React from 'react'
import MessageRouteEditor from './MessageRouteEditor'

function createEditor( messageRoute, props ) {
  if ( messageRoute == null ) {
    return null
  }
  const nProps = { ...props, messageRoute }
  return <MessageRouteEditor {...nProps} /> 
}

exports.createEditor = createEditor
